import * as React from 'react';
import { Marker, InfoWindow } from 'react-google-maps';
class MarkerWithTooltip extends React.PureComponent<any, any> {
  state: any = {
    isOpen: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        isOpen: this.props.isOpen
      });
    }
  }
 
  render() {
    const { markerPosition, icon, renderTooltip, onMarkerClick, onTooltipClose } = this.props
    return <Marker
    position={markerPosition}
    icon={icon}
    onClick={() => {
      if (onMarkerClick) {
        onMarkerClick();
      } else {
        this.setState({ isOpen: true });
      }
    }}>
     {this.state.isOpen && <InfoWindow
     onCloseClick={() => {
       this.setState({ isOpen: false });
       if (onTooltipClose) {
        onTooltipClose();
       }
     }}>
       {renderTooltip()}
     </InfoWindow>}
   </Marker>
  }
}
export default MarkerWithTooltip;